import React from 'react';
import { Button } from '../Button/Button';

export interface MessagesTopBarActionsProps {
  onNewMessage?: () => void;
  onBell?: () => void;
}

/** Messages header actions — New message only. */
export function MessagesTopBarActions({ onNewMessage }: MessagesTopBarActionsProps) {
  return (
    <div className="flex shrink-0 items-center justify-end gap-2">
      <Button variant="primary" size="sm" iconLeft="plus" onClick={onNewMessage}>
        New message
      </Button>
    </div>
  );
}
